/** Gumlet sources for Machu Picchu retreat (single place to tweak dimensions). */
export const machuAssets = {
  heroBg:
    'https://vinc.gumlet.io/pics/conventions/machu-picchu-retreat/dark-header.jpg?w=1920&dpr=2',
  logo:
    'https://vinc.gumlet.io/pics/conventions/machu-picchu-retreat/the-retreat-machu-picchu-logo.png?w=800&dpr=2',
  /** Full-bleed landscape below introduction */
  introWide:
    'https://vinc.gumlet.io/pics/conventions/machu-picchu-retreat/header-bg.jpg?w=1800&dpr=2',
} as const
